import { PropsWithChildren, memo } from "react";
import { Typography } from "components/typography";

type PageHeaderProps = {
  translation: string;
  mb?: number | null;
  hasSensitive: boolean | null;
};

const PageHeader = ({
  translation,
  hasSensitive,
  mb = null,
}: PropsWithChildren<PageHeaderProps>) => {
  const margin = mb ? `0 0 ${mb * 4}px 0` : 0;
  return (
    <Typography
      variant="h1"
      data-testid="cy-page-header"
      style={{ margin }}
      insensitive={!(hasSensitive ?? false)}
    >
      {translation}
    </Typography>
  );
};

export default memo(PageHeader);
